import { Button, Spinner } from 'alurkerja-ui';
import { Plus } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';

// Task
import { Approval } from './Approval';
import { UploadSuratSakit } from './UploadSuratSakit';
import { DetailApplication } from '@/utils/types/permit';
import { useFetch } from '@/hooks/useFetch';
import { Section } from '@/components/shared/section/Section';

export const DetailTask = () => {
  const params = useParams();
  const navigate = useNavigate();

  const { data, isLoading } = useFetch<DetailApplication>({
    path: `/workflow/v1/bpmn/${params.bpmnProcessId}/${params.instanceID}`,
  });

  const actionButton = () => (
    <div className="flex items-center gap-4">
      <Button icon={<Plus size={12} />} onClick={() => navigate('history')}>
        History
      </Button>
      <Button icon={<Plus size={12} />} onClick={() => navigate('bpmn')}>
        BPMN
      </Button>
    </div>
  );

  if (!params.elementID || !params.bpmnProcessId) {
    return <>URL not Valid</>;
  }

  return (
    <div className="border rounded">
      <Section title="Detail Pengajuan" action={actionButton}>
        <div className="p-6">
          {isLoading ? (
            <div className="flex gap-2.5 items-center" data-testid="loading">
              <Spinner className="text-main-blue-alurkerja" />
              Sedang Mengambil Data Pengajuan...
            </div>
          ) : (
            <>
              <>{params.elementID === 'approvalTribeLead' && <Approval data={data} approveBy="TRIBE_LEAD" />}</>
              <>{params.elementID === 'approvalPeopleGrowth' && <Approval data={data} approveBy="PG" />}</>
              <>
                {params.elementID === 'uploadSuratSakit' && (
                  <Approval data={data} renderAction={() => <UploadSuratSakit data={data} />} />
                )}
              </>
            </>
          )}
        </div>
      </Section>
    </div>
  );
};
